import React from 'react';
import { SideMenuItemViewModel } from '../N40SideMenu';
import { Link } from '~/lib/data-contract';
import { StyledSubMenuLink, StyledSubMenuTitle } from '../styled';

interface SideMenuLinkProps {
    menu: SideMenuItemViewModel;
    breadcrumbs?: Link[];
    level: 'level0' | 'level1';
}

export const SideMenuLink = React.memo(({ menu, breadcrumbs, level }: SideMenuLinkProps) => {
    const { name, url } = menu;
    const isCurrent = (breadcrumbs?.findIndex((crumb) => crumb.url == url) ?? -1) > -1;
    return (
        <StyledSubMenuLink
            href={url}
            prefetch={false}
            title={name}
            level={level}
            current={isCurrent}
            strokeHeight={level === 'level0' && isCurrent ? 0 : 1}
            children={
                <StyledSubMenuTitle variant={level === 'level0' ? 'body' : 'bodySm'}>
                    {name}
                </StyledSubMenuTitle>
            }
        />
    );
});
